<template>
  <q-list padding bordered class="rounded-borders">
    <q-item v-if="progresses.length < 1">
      {{ $t('generic.text.noData') }}
    </q-item>
    <q-expansion-item
      v-for="progress in progresses"
      v-else
      :key="progress.id"
      expand-separator
      dense-toggle
      group="progresses"
    >
      <template #header>
        <q-item-section avatar>
          <q-avatar
            color="white"
            text-color="black"
            icon="far fa-comment-dots"
          />
        </q-item-section>

        <q-item-section>
          <span> {{ $t(SERVICE_VALUE[parseInt(progress.type)]) }}</span>
          <span class="text-primary">
            {{ $filters.formatDate(progress.createdAt) }}
          </span>
        </q-item-section>

        <q-item-section side>
          <q-badge
            :color="PROCESS_COLOR[parseInt(progress.status)]"
            :label="
              $t(`service.process.${PROCESS_VALUE[parseInt(progress.status)]}`)
            "
          />
        </q-item-section>
      </template>

      <q-card>
        <q-card-section>
          <q-chat-message :name="$t('chat.me')" sent>
            <div>
              <p>{{ progress.value.note }}</p>
              <div class="q-gutter-sm">
                <q-badge v-if="progress.value.location">
                  {{ $t('service.table.location') }}:
                  {{ progress.value.location }}
                </q-badge>
                <q-badge v-if="progress.value.passenger">
                  {{ $t('service.table.passenger') }}:
                  {{ progress.value.passenger }}
                </q-badge>
                <q-badge v-if="progress.value.phone">
                  {{ $t('service.table.phone') }}:
                  {{ progress.value.phone }}
                </q-badge>
                <q-badge v-if="progress.value.time">
                  {{ $t('service.table.time') }}:
                  {{ progress.value.time }}
                </q-badge>
              </div>
            </div>
          </q-chat-message>
          <q-chat-message
            v-if="progress.note"
            :name="$t('chat.agent')"
            :text="[progress.note]"
            text-color="white"
            bg-color="primary"
          />
        </q-card-section>
      </q-card>
    </q-expansion-item>
  </q-list>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import { SERVICE_VALUE, PROCESS_VALUE, PROCESS_COLOR } from '@/constants';

export default {
  name: 'Progress',
  data() {
    return {
      SERVICE_VALUE,
      PROCESS_VALUE,
      PROCESS_COLOR,
      expanded: true,
      progresses: [],
    };
  },
  computed: {
    ...mapState({
      personalInfo: (state) => state.user.personalInfo,
    }),
  },
  created() {
    this.getProgress(this.personalInfo.userid)
      .then((res) => {
        this.progresses = res
          .sort((a, b) => a.status - b.status)
          .sort((a, b) => this.$moment(b.createdAt) - this.$moment(a.createdAt))
          .map((item) => {
            return { ...item, value: JSON.parse(item.value) };
          });
        console.log(res);
      })
      .catch((err) => {
        console.log(err);

        this.$notify.create({
          type: 'negative',
          position: 'top',
          message: this.$t('progress.getInfo.failed'),
          caption: err.response.data,
        });
      });
  },
  methods: {
    ...mapMutations({
      clearCurrentDetail: 'service/CLEAR_CURRENT_DETAIL',
    }),
    ...mapActions({
      getProgress: 'service/getProgress',
    }),
  },
  onUnmounted() {
    this.clearCurrentDetail();
  },
};
</script>
